import { render, staticRenderFns } from "./VersionSwitcher.vue?vue&type=template&id=4ee846d2"
import script from "./VersionSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./VersionSwitcher.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VersionSwitcher.vue?vue&type=style&index=0&id=4ee846d2&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports